// extracted by mini-css-extract-plugin
export default {"container":"CopyCheckedModal_container__xVqkN","placeHolderShimmer":"CopyCheckedModal_placeHolderShimmer__BmdGK"};